module.exports = __webpack_public_path__ + "img/biaoqian_zhongyaokeyandanwei.4c99ac53.png";